import styled from 'styled-components';
import { Form } from 'antd';

export const FormStyled = styled(Form)`
  align-items: flex-end;
  display: flex; 
  padding-bottom: 20px;

  & .ant-form-item {
    align-items: flex-end;
    display: flex;
  }

  & .ant-form-item-children {
    display: flex;
    align-items: center;
  }

  & .ant-input-affix-wrapper {
    display: flex;
    align-items: center;
  }
`;

export default { FormStyled };


// WEBPACK FOOTER //
// ./src/components/FormGuestData/styles.js